import styled from "styled-components";
import { useSelector } from "react-redux";
import ar from "../../util/locales/ar";
import en from "../../util/locales/en";
import { ReactComponent as ClockIcon } from "../assets/icons/clock.svg";
import { ReactComponent as BulbIcon } from "../assets/icons/bulb.svg";
import { ReactComponent as BankIcon } from "../assets/icons/bank.svg";

const ChooseUs = () => {
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;

  return (
    <Wrapper>
      <CarImg src="/imgs/finance_car.png" alt="about-car" />
      <div>
        <Header>{t.about.choose.title}</Header>
        <Card>
          <TopBox>
            <IconWrapper>
              <ClockIcon />
            </IconWrapper>
            <TopText>{t.about.choose.card.text1}</TopText>
          </TopBox>

          <InfoRow>
            <CircleIcon>
              <BulbIcon />
            </CircleIcon>
            <Text>
              {t.about.choose.card.text2}
              <br />
              <BrandSpan>{t.about.choose.card.brand}</BrandSpan>
            </Text>
          </InfoRow>

          <InfoRow>
            <CircleIcon>
              <BankIcon />
            </CircleIcon>
            <Text>{t.about.choose.card.text3}</Text>
          </InfoRow>
        </Card>
      </div>
    </Wrapper>
  );
};

export default ChooseUs;

const Header = styled.h1`
  color: #0d0a19;
  font-weight: 700;
  font-size: 42px;
  line-height: 50px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 20px;
    text-align: center;
    margin-bottom: 8px;
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
  padding: 2rem 0;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const CarImg = styled.img`
  max-width: 520px;
  width: 100%;
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  width: 100%;
`;

const TopBox = styled.div`
  background-color: #0057d9;
  border-radius: 10px;
  padding: 1rem;
  color: white;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
`;

const IconWrapper = styled.div`
  svg {
    width: 60px;
    height: 60px;
    color: #0057d9;

    @media (max-width: 768px) {
      width: 30px;
      height: 30px;
    }
  }
`;

const TopText = styled.div`
  font-size: 1rem;
  font-weight: 600;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 0;
  border-top: 1px solid #eee;

  &:first-of-type {
    border-top: none;
  }
`;

const CircleIcon = styled.div`
  background-color: #f3f6f9;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 30px;
    height: 30px;
    color: #1a1a1a;
  }
`;

const Text = styled.p`
  font-size: 0.95rem;
  font-weight: 500;
  color: #3a3a3a;
  line-height: 1.4;
`;

const BrandSpan = styled.span`
  color: #0057d9;
  font-weight: 600;
`;
